import { CommonModule, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-especialista-documentacion',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './create-especialista-documentacion.component.html',
  styleUrl: './create-especialista-documentacion.component.css',
})
export class CreateEspecialistaDocumentacionComponent implements OnInit {
  createSpecialistaForm!: FormGroup;
  asignarRolForm!: FormGroup;
  unidadesFuncionales: any[] = [];
  areas: any[] = [];
  isFormDirty = false;
  showPassword = false;
  id_rol!: number;
  showUnidadFuncional: boolean = false;
  showArea: boolean = false;
  codigoDocumentoBusqueda: string = '';
  tipoDocumentoBusqueda: string = '';
  usuarioEncontrado: any = null;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Formulario para crear nuevo especialista
    this.createSpecialistaForm = this.fb.group({
      tipo_documento: ['', Validators.required],
      codigo_documento: ['', Validators.required],
      nombres: ['', Validators.required],
      apellidos: ['', Validators.required],
      correo: ['', [Validators.required, Validators.email]],
      clave: ['', Validators.required],
      id_unidad_funcional: [null, Validators.required], // Campo para Unidad Funcional
      id_area: [null, Validators.required], // Campo para Área
    });

    // Formulario para asignar rol a usuario existente
    this.asignarRolForm = this.fb.group({
      id_unidad_funcional: [null, Validators.required],
      id_area: [null, Validators.required],
    });

    this.route.queryParams.subscribe((params) => {
      const id_rol = parseInt(params['id_rol'], 10);
      if (!isNaN(id_rol)) {
        this.id_rol = id_rol;
        this.updateFormFields();
      } else {
        Swal.fire('Error', 'Rol no válido.', 'error');
        this.router.navigate(['/especialistas-documentacion']);
      }
    });

    this.createSpecialistaForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    this.loadUnidadesFuncionales();
    this.loadAreas();
  }

  buscarUsuario() {
    if (!this.codigoDocumentoBusqueda || !this.tipoDocumentoBusqueda) {
      Swal.fire('Advertencia', 'Debe ingresar el tipo de documento y el codigo de documento.', 'warning');
      return;
    }


    this.http
      .get(`${environment.apiUrl}/usuario/${this.tipoDocumentoBusqueda}/${this.codigoDocumentoBusqueda}`)
      .subscribe(
        (response: any) => {
          this.usuarioEncontrado = response;
          Swal.fire('Éxito', 'Usuario encontrado.', 'success');
        },
        (error) => {
          Swal.fire('Error', error.error.message || 'Usuario no encontrado.', 'error');
          this.usuarioEncontrado = null;
        }
      );
  }

  async crearUsuario() {
    // Crear el payload para crear el usuario
    const usuarioPayload = {
      tipo_documento: this.createSpecialistaForm.value.tipo_documento,
      codigo_documento: this.createSpecialistaForm.value.codigo_documento,
      nombres: this.createSpecialistaForm.value.nombres,
      apellidos: this.createSpecialistaForm.value.apellidos,
      correo: this.createSpecialistaForm.value.correo,
      clave: this.createSpecialistaForm.value.clave,
    };

    // Enviar el POST para crear el usuario
    this.http.post(`${environment.apiUrl}/usuario`, usuarioPayload).subscribe(
      (user: any) => {
        // Si el usuario se crea correctamente, asignar el rol
        const rolPayload: any = {
          id_usuario: user.id_usuario, // ID del usuario recién creado
          id_rol: this.id_rol, // ID del rol seleccionado
        };

        // Agregar el campo correspondiente al rol
        if (this.id_rol === 2) {
          rolPayload.id_unidad_funcional = parseInt(
            this.createSpecialistaForm.value.id_unidad_funcional,
            10
          );
        } else if (this.id_rol === 3) {
          rolPayload.id_area = parseInt(
            this.createSpecialistaForm.value.id_area,
            10
          );
        }

        // Enviar el POST para asignar el rol
        this.http
          .post(`${environment.apiUrl}/rol-usuario`, rolPayload)
          .subscribe(
            () => {
              Swal.fire(
                'Éxito',
                'Usuario creado y rol asignado con éxito.',
                'success'
              ).then(() => {
                this.router.navigate(['/especialistas-documentacion']);
              });
            },
            (error) => {
              Swal.fire('Error', error.error.message || 'No se pudo asignar el rol.', 'error');
              console.error('Error al asignar rol:', error);
            }
          );
      },
      (error) => {
        Swal.fire('Error', error.error.message || 'No se pudo crear el usuario.', 'error');
        console.error('Error al crear usuario:', error);
      }
    );
  }

  asignarRol() {
    const payload: any = {
      id_usuario: this.usuarioEncontrado.id_usuario,
      id_rol: this.id_rol,
    };
    if (this.id_rol === 2) {
      payload.id_unidad_funcional = parseInt(
        this.asignarRolForm.value.id_unidad_funcional,
        10
      );
    } else if (this.id_rol === 3) {
      payload.id_area = parseInt(this.asignarRolForm.value.id_area, 10);
    }
    //console.log(payload);
    this.http.post(`${environment.apiUrl}/rol-usuario`, payload).subscribe(
      () => {
        Swal.fire('Éxito', 'Rol asignado con éxito.', 'success').then(() => {
          this.router.navigate(['/especialistas-documentacion']);
        });
      },
      (error) => {
        //console.error(error);
        Swal.fire('Error', error.error.message || 'Error al asignar el rol.', 'error');
      }
    );
  }
  updateFormFields(): void {
    if (this.id_rol === 2) {
      this.showUnidadFuncional = true;
      this.showArea = false;
      this.createSpecialistaForm.get('id_unidad_funcional')?.setValidators([Validators.required]);
      this.createSpecialistaForm.get('id_area')?.clearValidators();
      this.asignarRolForm.get('id_unidad_funcional')?.setValidators([Validators.required]);
      this.asignarRolForm.get('id_area')?.clearValidators();
    } else if (this.id_rol === 3) {
      this.showUnidadFuncional = false;
      this.showArea = true;
      this.createSpecialistaForm.get('id_area')?.setValidators([Validators.required]);
      this.createSpecialistaForm.get('id_unidad_funcional')?.clearValidators();
      this.asignarRolForm.get('id_area')?.setValidators([Validators.required]);
      this.asignarRolForm.get('id_unidad_funcional')?.clearValidators();
    }
    this.createSpecialistaForm.get('id_unidad_funcional')?.updateValueAndValidity();
    this.createSpecialistaForm.get('id_area')?.updateValueAndValidity();
    this.asignarRolForm.get('id_unidad_funcional')?.updateValueAndValidity();
    this.asignarRolForm.get('id_area')?.updateValueAndValidity();
  }

  loadUnidadesFuncionales() {
    this.http.get(environment.apiUrl + '/unidad-funcional').subscribe(
      (data: any) => {
        this.unidadesFuncionales = data;
      },
      (error) => {
        console.error('Error al obtener unidades funcionales:', error);
      }
    );
  }

  loadAreas() {
    this.http.get(environment.apiUrl + '/area').subscribe(
      (data: any) => {
        this.areas = data;
      },
      (error) => {
        console.error('Error al obtener áreas:', error);
      }
    );
  }

  // onSubmit() {
  //   if (this.createSpecialistaForm.valid) {
  //     const specialistPayload = {
  //       dni: this.createSpecialistaForm.value.dni,
  //       nombres: this.createSpecialistaForm.value.nombres,
  //       apellidos: this.createSpecialistaForm.value.apellidos,
  //       correo: this.createSpecialistaForm.value.correo,
  //       clave: this.createSpecialistaForm.value.clave,
  //     };

  //     // Crear usuario
  //     this.http
  //       .post(environment.apiUrl + '/usuario', specialistPayload)
  //       .subscribe(
  //         (user: any) => {
  //           const rolPayload: any = {
  //             id_usuario: user.id_usuario,
  //             id_rol: this.id_rol,
  //           };

  //           if (this.id_rol === 2) {
  //             rolPayload.id_unidad_funcional = parseInt(
  //               this.createSpecialistaForm.value.id_unidad_funcional
  //             );
  //           } else if (this.id_rol === 3) {
  //             rolPayload.id_area = parseInt(
  //               this.createSpecialistaForm.value.id_area
  //             );
  //           }

  //           // Asignar rol
  //           this.http
  //             .post(environment.apiUrl + '/rol-usuario', rolPayload)
  //             .subscribe(
  //               () => {
  //                 Swal.fire(
  //                   'Éxito',
  //                   'Especialista creado con éxito.',
  //                   'success'
  //                 ).then(() => {
  //                   this.router.navigate(['/especialistas-documentacion']);
  //                 });
  //               },
  //               (error) => {
  //                 Swal.fire('Error', error.error.message, 'error');
  //                 console.error('Error al asignar rol:', error);
  //               }
  //             );
  //         },
  //         (error) => {
  //           Swal.fire('Error', error.error.message, 'error');
  //           console.error('Error al crear usuario:', error);
  //         }
  //       );
  //   }
  // }

  onBack() {
    if (this.isFormDirty && !confirm('¿Está seguro de salir?')) {
      return;
    }
    this.router.navigate(['/especialistas-documentacion']);
  }

  @HostListener('window:beforeunload', ['$event'])
  handleUnload(event: Event) {
    if (this.isFormDirty) {
      event.returnValue = true;
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
